import { api } from '@cma/app'
import {
  UnsharePlatformClientResourceMutation,
  UnsharePlatformClientResourceMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

interface UnsharePlatformClientResourcesProps {
  accountId: string
}

export function useUnsharePlatformClientResource({
  accountId
}: UnsharePlatformClientResourcesProps) {
  const queryClient = useQueryClient()

  return useMutation<
    UnsharePlatformClientResourceMutation,
    Error,
    UnsharePlatformClientResourceMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation UnsharePlatformClientResource(
          $shareTarget: ShareTargetInput!
          $shareableContent: ShareableContentInput!
        ) {
          unsharePlatformClientResource(
            shareTarget: $shareTarget
            shareableContent: $shareableContent
          ) {
            errors
            success
          }
        }
      `

      return api<
        UnsharePlatformClientResourceMutation,
        UnsharePlatformClientResourceMutationVariables
      >({
        query,
        variables
      })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: accountId }
        ])
      }
    }
  )
}
